import {
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from '@mui/material';
import { Pencil, Trash2 } from 'lucide-react';
import { useState } from 'react';

export default function ChatDropdown({ reference, onRename, onDelete }) {
  const [open, setOpen] = useState(true); // Start open on mount

  const handleClose = () => {
    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === 'Tab' || event.key === 'Escape') {
      handleClose();
    }
  };
  return (
    <Popper
      open={open}
      anchorEl={reference}
      role={undefined}
      placement="bottom-end"
      sx={{ zIndex: 20 }}
      transition
      disablePortal
    >
      {({ TransitionProps }) => (
        <Grow {...TransitionProps} style={{ transformOrigin: 'right top' }}>
          <Paper className="rounded-xl" sx={{ borderRadius: 3 }}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList
                autoFocusItem={open}
                onKeyDown={handleListKeyDown}
                sx={{ my: 1 }}
              >
                <MenuItem
                  onClick={() => {
                    onRename();
                    handleClose();
                  }}
                  sx={{ fontFamily: 'inherit', gap: 0.5 }}
                >
                  <Pencil size={16} className="mr-2" />
                  Rename
                </MenuItem>
                <MenuItem
                  onClick={(e) => {
                    onDelete(e);
                    handleClose();
                  }}
                  sx={{ color: '#ea1c2d', fontFamily: 'inherit', gap: 0.5 }}
                >
                  <Trash2 size={16} className="mr-2" />
                  Delete
                </MenuItem>
              </MenuList>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
}
